module.exports = __webpack_public_path__ + "img/bermuda1.8264ac51.jpg";